import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';

class Theme {
  primaryColor: string = "#0072c6";
  secondaryColor: string = "#dee3f3";
  headerIconColor: string = "#ffffff";
  borderColor: string = "#cacaca";
  menuHoverColor: string = "#dce6f4";
  bodyColor: string = "#ffffff";
  navHover: string = "#FFFFFF19";
  textColor: string = "#808080"
}

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private baseUrl = `${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}Theme`;
  themesJson: Theme = new Theme();

  constructor(
    private httpClient: HttpClient,
    private env: EnvironmentService
  ) {}

  private themeJson = new BehaviorSubject<Theme>(this.themesJson);
  public ThemeJson = this.themeJson.asObservable(); //contains jobName which is active/ clicked 

  getTheme() {
    return this.themesJson;
  }

  updateTheme(theme: Theme) {
    this.themesJson = theme;
    this.changeGlobalVars();
    // this.themeJson.next(this.themesJson);
  }

  changeGlobalVars(){
    document.documentElement.style.setProperty('--s-primary-color', this.themesJson.primaryColor);
    document.documentElement.style.setProperty('--s-secondary-color', this.themesJson.secondaryColor);
    document.documentElement.style.setProperty('--s-headerIcon-color', this.themesJson.headerIconColor);
    document.documentElement.style.setProperty('--s-border-color', this.themesJson.borderColor);
    document.documentElement.style.setProperty('--s-menuHover-color', this.themesJson.menuHoverColor);
    document.documentElement.style.setProperty('--s-nav-hover', this.themesJson.navHover);
    document.documentElement.style.setProperty('--s-body-color', this.themesJson.bodyColor || "#ffffff");
    document.documentElement.style.setProperty('--s-text-color', this.themesJson.textColor || "#808080");
  }

  getThemesJson(): Observable<string>{
    const url = `${this.baseUrl}/GetParams`;
    return this.httpClient.get<string>(url).pipe(
      map(data => {
        if(JSON.stringify(data) != "{}"){
          this.themesJson = JSON.parse(JSON.stringify(data));
          this.themeJson.next(this.themesJson);
          this.changeGlobalVars();
        }
        return data;
      }),
      catchError(error => {
        console.error('There was an error!', error?.error?.message);
        throw error; // Re-throw the error to propagate it to the subscriber
      })
    );
  
  }

  updateThemesJson(newJson: string) {
    const url = `${this.baseUrl}/UpdateParams`;
    return this.httpClient.post(url, null, { headers: { newJson: newJson } });
  }
}
